import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "backdrop", "icon", "name", "description", "points", "rarityBadge", "rarityContainer"]

  connect() {
    // Listen for achievement unlock events from notifications
    document.addEventListener('achievement:unlocked', this.show.bind(this))
  }

  disconnect() {
    document.removeEventListener('achievement:unlocked', this.show.bind(this))
  }

  show(event) {
    const achievement = event.detail

    // Update modal content
    this.updateContent(achievement)

    // Show modal with animation
    this.element.classList.remove('hidden')

    requestAnimationFrame(() => {
      this.backdropTarget.classList.add('opacity-100')
      this.containerTarget.classList.remove('opacity-0', 'scale-95')
      this.containerTarget.classList.add('opacity-100', 'scale-100')
    })

    // Prevent body scroll
    document.body.style.overflow = 'hidden'

    // Play celebration sound (optional)
    this.playCelebrationSound()
  }

  updateContent(achievement) {
    // Update icon (use emoji or achievement icon)
    if (this.hasIconTarget) {
      this.iconTarget.textContent = achievement.icon || '🏆'
    }

    // Update name
    if (this.hasNameTarget) {
      this.nameTarget.textContent = achievement.name || 'Achievement Unlocked!'
    }

    // Update description
    if (this.hasDescriptionTarget) {
      this.descriptionTarget.textContent = achievement.description || ''
    }

    // Update points
    if (this.hasPointsTarget) {
      this.pointsTarget.textContent = achievement.points || 0
    }

    // Update rarity badge
    if (this.hasRarityBadgeTarget && achievement.rarity) {
      const rarityColors = {
        common: 'bg-gray-200 text-gray-800',
        uncommon: 'bg-green-200 text-green-800',
        rare: 'bg-blue-200 text-blue-800',
        epic: 'bg-purple-200 text-purple-800',
        legendary: 'bg-yellow-200 text-yellow-800'
      }

      const colorClass = rarityColors[achievement.rarity.toLowerCase()] || rarityColors.common
      this.rarityBadgeTarget.className = `px-3 py-1 rounded-full text-sm font-semibold ${colorClass}`
      this.rarityBadgeTarget.textContent = achievement.rarity.charAt(0).toUpperCase() + achievement.rarity.slice(1)
    }
  }

  close(event) {
    if (event) {
      event.preventDefault()
    }

    // Hide modal with animation
    this.backdropTarget.classList.remove('opacity-100')
    this.containerTarget.classList.remove('opacity-100', 'scale-100')
    this.containerTarget.classList.add('opacity-0', 'scale-95')

    setTimeout(() => {
      this.element.classList.add('hidden')
      document.body.style.overflow = ''
    }, 200)
  }

  viewAchievements(event) {
    event.preventDefault()
    this.close()
    // Redirect to achievements page
    window.location.href = '/gamification/achievements'
  }

  playCelebrationSound() {
    // Optional: Play a celebration sound
    // You can add an audio element or use Web Audio API
    try {
      const audio = new Audio('/sounds/achievement-unlock.mp3')
      audio.volume = 0.3
      audio.play().catch(() => {
        // Ignore errors if sound can't play
      })
    } catch (error) {
      // Sound is optional, ignore errors
    }
  }

  // Close modal when clicking outside
  clickOutside(event) {
    if (event.target === this.element) {
      this.close()
    }
  }

  // Close modal with Escape key
  closeWithEscape(event) {
    if (event.key === 'Escape') {
      this.close()
    }
  }
}
